import { Button, Icon, Modal } from '@octano/global-ui';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from 'reactstrap';
import { TranslationsKeys } from '../../../../../../locales/translations';

export interface ConflictModalRef {
  openModal: () => void;
  closeModal: () => void;
}

const ConfictModal = forwardRef<ConflictModalRef>((_, ref) => {
  const { t } = useTranslation(TranslationsKeys.MANAGEMENT_TOOLS_SURVEY);

  const [modal, setModal] = useState(false);

  useImperativeHandle(ref, () => ({
    openModal() {
      setModal(true);
    },
    closeModal() {
      setModal(false);
    },
  }));

  return (
    <Modal isOpen={modal} toggle={() => setModal(!modal)}>
      <Container fluid className="text-center">
        <Icon name="warning" size={45} />
        <p className="text-dark fs-22 mt-3 mb-4">
          {t('surveyCreation.conflictModal.title')}
        </p>
        <p className="text-dark fs-18 mt-3 mb-4">
          {t('surveyCreation.conflictModal.description')}
        </p>
        <div className="d-flex justify-content-around" style={{ gap: 10 }}>
          <div className="flex-fill">
            <Button
              className="w-100"
              text={'Entendido'}
              onClick={() => {
                setModal(false);
              }}
            />
          </div>
        </div>
      </Container>
    </Modal>
  );
});

export default ConfictModal;
